export interface App {
    name: string;
    version: string;
}

export interface CoreRequest {
    correlation_id: string;
    params: Record<string, string>;
    path: string;
    session_id: string;
}

export interface CoreRequestExtraData {
    ip: string;
    host: string;
    httpReferer?: string;
    method: string;
}

export enum CaptchaStatus {
    notLoaded = 'notLoaded',
    loaded = 'loaded',
    loading = 'loading',
}
